import type { AppFeatures } from "./types";

// should be used if there are issues with initializing GrowthBook (e.g. network issues, invalid client key, etc.) to ensure that the app has some default feature values to fall back on
export const defaultValues: AppFeatures = {
  "additional-services-selection": false,
  bnpl: true,
  "hotels-flow": true,
  "multi-room-booking": false,
  "optional-tours": true,
  "promo-codes": true,
  "trips-flow": true,
  "flight-branded-fares": true,
};
